import { IAppState } from 'shared/common/state';
import { TBuilderChatOnboardingType } from 'shared/types/chatOnboarding';

export function selectBuilderOnboardingToForceClosing(state: IAppState): TBuilderChatOnboardingType | undefined {
  return state.chatOnboarding.builderOnboardingToForceClosing;
}
